enum MemberTypes {
  STARTER = 'starter',
  BENCH = 'bench',
  STAFF = 'staff',
}

const MemberTypeOptions = [
  { label: 'Starter', value: MemberTypes.STARTER },
  { label: 'Bench', value: MemberTypes.BENCH },
  { label: 'Staff', value: MemberTypes.STAFF },
];

type Member = {
  id?: string;
  name: string;
  number: string;
  type: MemberTypes;
  goals?: number;
  caps?: number;
  matches?: number;
  age?: number;
  // Only used by line-up preset 2.
  photoUrl?: string;
  goalsTournament?: number;
};

export { MemberTypes, MemberTypeOptions };

export type { Member };
